import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateBatteryPrice } from "./battery-price-dependents"
import type {
  BatteryProposalFinancingDto,
  SaveBatterySungageQuoteDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Save a BrightStart Loan Product and Quote. Provider terms may refresh at
 * Save the way Concert save does, so both success and failure refresh
 * everything downstream of the stored price.
 */
export default function useSaveBatterySungageQuote(): UseMutationResult<
  BatteryProposalFinancingDto,
  unknown,
  { proposalId: string; body: SaveBatterySungageQuoteDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.saveSungageQuote(proposalId, body),
    onError: (_error, { proposalId }) => {
      invalidateBatteryPrice(queryClient, proposalId)
    },
    onSuccess: (financing, { proposalId }) => {
      queryClient.setQueryData(
        queryKeys.batteryProposal.financing(proposalId),
        financing,
      )
      invalidateBatteryPrice(queryClient, proposalId)
    },
  })
}
